<section>
  <h1 class="header list-header">{{ 'DUE_PERIODS.RENT_PERIODS_CAPTION' | translate }}</h1>
  <app-list-view
    [columnDefinition]="columnDefinitions"
    [contextMenuDefinition]="contextMenuDefinitions"
    [itemsSource]="rentPeriods"
    [preferencesKey]="'rent.lease-agreement-rent-period-manager.list'"
  >
  </app-list-view>
</section>
